const state = {
  races: [],
  scheduleraces: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/racesByTrainer/state.js